<template>
    <div class="prospects-list">
        <search-bar v-if="renderFilters" :filters="searchBarFilters">
            <select2 slot="agencies"
                     :value="searchFilters.agencies"
                     @input="updateFilterDebounced($event, 'agencies')"
                     class="full-width"
                     multiple
                     :options="selectAgenciesList">
            </select2>
            <select2 slot="distribution_methods"
                     :value="searchFilters.distribution_methods"
                     @input="updateFilterDebounced($event, 'distribution_methods')"
                     placeholder="Tous"
                     class="full-width"
                     multiple
                     :options="filterContractOptionsList">
            </select2>
            <select2 slot="rbe_status"
                     :value="searchFilters.rbe_status"
                     @input="updateFilterDebounced($event, 'rbe_status')"
                     class="full-width"
                     :allow-clear="true"
                     :options="selectRbeStatusesList"
                     placeholder="Tous">
            </select2>
            <select2 slot="sap_promo_code"
                     :value="searchFilters.sap_promo_code"
                     class="full-width"
                     placeholder="Tous"
                     @input="updateFilterDebounced($event, 'sap_promo_code')"
                     :allow-clear="true"
                     :options="selectSapPromoCodes">
            </select2>
            <a slot="export_button" 
                :href="exportLinkHref" 
                target="_blank" 
                v-if="canExport"
                class="btn btn-default button-margin-bottom" 
                style="margin-bottom: 20px;"
            >
                <i class="fa fa-share-square-o"></i> Exporter
            </a>
        </search-bar>
        <template v-if="someCustomers">
            <pagination v-if="paginationNeeded"
                        :current-page="currentPage"
                        :total-pages="totalPages"
                        @click="getPageOnClick">
            </pagination>
            <customers-table :search-filters="searchFilters"
                             :customers="currentCustomers">
            </customers-table>
            <pagination v-if="paginationNeeded"
                        :current-page="currentPage"
                        :total-pages="totalPages"
                        @click="getPageOnClick">
            </pagination>
        </template>
    </div>
</template>

<script type="text/babel">
    import SearchBar from "../../components/CustomersList/SearchBar"
    import CustomersTable from "../../components/CustomersList/CustomersTable"
    import Pagination from "components/Pagination"
    import routeWatcher from "mixins/routeWatcher"
    import { mapState, mapGetters, mapActions } from "vuex"
    import Select2 from "components/Form/Select2"
    import cookies from "cookiesjs"

    export default {
      name: "ProspectsList",

      mixins: [routeWatcher("getPage", "currentPage")],

      components: {
        SearchBar,
        CustomersTable,
        Pagination,
        Select2,
      },

      data() {
        return {
          getPageOnClick: null,
          scrollThrottled: null,
          scrolling: false,
          unwatchSelects: null,
          unwatchFilters: null,
          updateFilterDebounced: null,
          updateFiltersDebounced: null,
          renderAgenciesSelect: false,
          renderFilters: false,
          filterContractOptionsList: [
            { id: 1, text: "Domiciliation" },
            { id: 2, text: "Location longue-durée" },
          ],
          selectRbeStatusesList: [
            { id: 'not-concerned', text: 'Non concerné'},
            { id: 'inpi-documents-to-check', text: 'Document(s) INPI à contrôler'},
            { id: 'empty', text: 'Vide'},
            { id: 'update-required', text: 'À mettre à jour'},
            { id: 'validated', text: 'Validé'}
          ]
        }
      },

      created() {
        // console.info("some Customers?", this.someCustomers)

        this.getPageOnClick = _.debounce(this.getPage, 200)
        this.scrollThrottled = _.throttle(_ => {
          const $body = $("body, html"),
            scrollPos = $(window).scrollTop(),
            resultsPos = $(".search-results").scrollTop()
          if (this.scrolling) {
            $body.stop()
            this.scrolling = false
          }
          if (scrollPos > resultsPos) {
            this.scrolling = true
            $body.animate({ scrollTop: 0 }, 800, _ => (this.scrolling = false))
          }
        }, 100)

        this.updateFilterDebounced = _.debounce(this.updateFilter, 400)
        this.updateFiltersDebounced = _.debounce(this.updateFilters, 400)
        const evaluateStartingConditions = () =>
          this.agencies.length && this.userAgenciesIdList.length

        //            debugger
        if (this.someCustomers) {
          this.renderAgenciesSelect = true
          this.renderFilters = true
          this.getPage(this.currentPage)
          return
        }

        if (evaluateStartingConditions()) {
          // this.updateFilters({agencies: this.userAgenciesIdList})
          //            this.updateFilter(this.userAgenciesIdList, 'agencies')
          this.renderAgenciesSelect = true
          this.renderFilters = true
        } else {
          this.unwatchSelects = this.$watch(
            function() {
              return evaluateStartingConditions()
            },
            function(cond) {
              if (cond) {
                // this.updateFilters({agencies: this.userAgenciesIdList})
                //                        this.updateFilterDebounced(this.userAgenciesIdList, 'agencies')
                //this.getPage(this.currentPage)
                this.renderAgenciesSelect = true
                this.renderFilters = true
                this.unwatchSelects()
              }
            }
          )
        }
      },

      beforeRouteUpdate() {
        this.getPage(this.currentPage)
      },

      beforeDestroy() {
        _.isNull(this.unwatchFilters) || this.unwatchFilters()
      },

      methods: {
        ...mapActions("prospects", ["getCustomersPage", "updateFilters"]),

        getPage(idx) {
          this.scrollThrottled()
          const params = {
            prospects: true,
            idx,
          }

          return this.getCustomersPage(params)
        },

        updateFilter (value, filterName) {
          const toInsert = _.isArray(value) ? value : [value],
            diff1 = _.difference(this.searchFilters[filterName], toInsert),
            diff2 = _.difference(toInsert, this.searchFilters[filterName]),
            arrayChanged = !_.isEmpty(diff1) || !_.isEmpty(diff2)

          /*
              When user go back (e.g. by clicking on history back button)
              bindings on Select2 are refreshed somehow
              calling back this function
          */
          if (arrayChanged)
            this.updateFiltersDebounced({ [filterName]: _.isArray(value) ? toInsert : toInsert[0] })
        },
      },

      computed: {
        ...mapState({
          customers: state => state.prospects.paginatedList,
          currentPage: state => state.prospects.currentPage,
          searchFilters: state => state.prospects.searchFilters,
          userAgencies: state => state.user.agencies,
          agencies: state => state.agencies,
          user: state => state.user,
        }),

        ...mapGetters("prospects", [
          "totalPages",
          "currentCustomers",
          "someCustomers",
          "selectAgenciesList",
          "userAgenciesIdList",
        ]),

        ...mapGetters(["sapPromoCodes"]),

        paginationNeeded() {
          return this.totalPages > 1
        },

        renderAgenciesFilter() {
          return this.selectAgenciesList.length && this.userAgenciesIdList.length
        },

        searchBarFilters () {
          return {
            agencies: true,
            distributionMethods: true,
            status: false,
            contractInstructions: false,
            withContract: false,
            rbeStatus: true,
            sapPromoCode: true
          }
        },

        selectSapPromoCodes() {
          let collection = []
          let obj = {}

          for (let i = 0; i < this.sapPromoCodes.length; i++) {
          obj = {}
          obj['id'] = this.sapPromoCodes[i]
          obj['text'] = this.sapPromoCodes[i]
          collection.push(obj)
          }

          return collection
        },

        canExport() {
          return _.find(this.user.me.groups, group => group.name == "export") !== undefined
        },

        exportLinkParams() {
          let queryParams = new URLSearchParams();

          queryParams.append('token', cookies('token'))

          if (this.searchFilters.agencies) {
            this.searchFilters.agencies.forEach(agencyId => {
                queryParams.append('agencies[]', agencyId)
            });
          }

          if (this.searchFilters.rbe_status) {
            queryParams.append('rbe_status', this.searchFilters.rbe_status)
          }
          
          if (this.searchFilters.distribution_methods) {
            this.searchFilters.distribution_methods.forEach(distributionMethodId => {
                queryParams.append('distribution_methods[]', distributionMethodId)
            });
          }

          if (this.searchFilters.sap_promo_code) {
            queryParams.append('sap_promo_code', this.searchFilters.sap_promo_code)
          }

          // queryParams.append('validated', 0)
          queryParams.append('orderBy', 'created_at')
          queryParams.append('sortedBy', 'desc')

          return queryParams.toString()
        },

        exportLinkHref() {
          return __API_URL__ + '/customers/export?' + this.exportLinkParams
        }
      },
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// client/views/Customers/ProspectsList.vue